import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rentals-checklists',
  templateUrl: './rentals-checklists.component.html',
  styleUrls: ['./rentals-checklists.component.scss']
})
export class RentalsChecklistsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
